// App.js
import React, { useEffect } from "react";
import emailjs from "@emailjs/browser";
import Header from "./components/Header";
import PhotoGallery from "./components/PhotoGallery";
import TextBox from "./components/TextBox";
import BedroomGallery from "./components/BedroomGallery";
import ContactForm from "./components/ContactForm";
import FarewellMessage from "./components/FarewellMessage";
import "./App.css";

function App() {
  useEffect(() => {
    // Initialize EmailJS
    emailjs.init("eSROwPSPveI1cqT4H");
  }, []);

  return (
    <div
      className="app-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/sunflowerBackground.png)`,
        backgroundRepeat: "repeat",
        backgroundSize: "cover",
      }}
    >
      <Header className="app-header" />
      <PhotoGallery />
      <TextBox />
      <BedroomGallery />
      <ContactForm />
      <FarewellMessage />
    </div>
  );
}

export default App;
